import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Select from 'react-select';

import Overlay from '../../Miscelania/Overlay';

import LogbookSignatureModal from '../../LogbookAppIntegration/LogbookSignatureModal';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookReportsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          logbook_app: this.props.logbook_app,
          report_trash: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          aircraft_logbook_flight_id: '',
          aircraft_logbook_report_id: '',
          location_id: '',
          user_id: '',
          date: '',
          description: '',
          reports: {},
          flight_legs_list: [],
          locations_list: [],
          users_list: [],
          bases_list: [],
          approval_type: '',
          email: '',
          password: '',
          showLogbookSignatureModal: false,
          signature_modal_title: '',
          signature_modal_subtitle: '',
          signature_modal_confirmation: '',
        };
        this.add = this.add.bind(this);
        this.delete = this.delete.bind(this);
        this.approve = this.approve.bind(this);
        this.handleApproval = this.handleApproval.bind(this);
        this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
    
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            logbook_app: newProps.logbook_app,
            report_trash: newProps.report_trash,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.reports !== 'undefined' && newProps.reports !== null && this.state.loaded === 1) {
          this.setState({
            report_trash: newProps.report_trash,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            reports: newProps.reports,
          });
        }

        if(typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null && this.state.loaded === 1) {
          this.setState({
            report_trash: newProps.report_trash,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            flight_legs_list: newProps.flight_legs_list,
          });
        }

        if(typeof newProps.users_list !== 'undefined' && newProps.users_list !== null && this.state.loaded === 1) {
          this.setState({
            report_trash: newProps.report_trash,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            users_list: newProps.users_list,
          });
        }

        if(typeof newProps.bases_list !== 'undefined' && newProps.bases_list !== null && this.state.loaded === 1) {
          this.setState({
            report_trash: newProps.report_trash,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            bases_list: newProps.bases_list,
          });
        }

        if(typeof newProps.locations_list !== 'undefined' && newProps.locations_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            locations_list: newProps.locations_list,
          });
        }

      }
      
      // Fetch salvando o reporte
      add(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          aircraft_logbook_flight_id: this.state.aircraft_logbook_flight_id,
          location_id: this.state.location_id,
          user_id: this.state.user_id,
          date: this.state.date,
          description: this.state.description,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/aeronave/diario/reporte', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              aircraft_logbook_flight_id: '',
              location_id: '',
              user_id: '',
              date: '',
              description: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      delete () {
        var confirm = window.confirm('Are you sure that you want to delete this report?');
        if (confirm) {
          this.props.handleAlert('', '', 'open');
          const datasave = {
            aircraft_logbook_report_id: this.state.aircraft_logbook_report_id,
            email: this.state.email,
            password: this.state.password
          };
          var url = config.get('api') + '/aeronave/diario/reporte/deletar';
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function(value) {
            fetch(url, { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({
                aircraft_logbook_report_id: '',
                approval_type: '',
                email: '',
                password: '',
                signature_modal_title: '',
                signature_modal_subtitle: '',
                signature_modal_confirmation: ''
              });
              if (responseJson.status === 'success') {
                self.props.updateData(responseJson);
              }
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }

      // Aprova internamente e, se estiver ativada a integração, envia para o Logbook App
      approve() {
        this.props.handleAlert('', '', 'open');
        const datasave = {
          aircraft_logbook_report_id: this.state.aircraft_logbook_report_id,
          email: this.state.email,
          password: this.state.password
        };
        var url = config.get('api') + '/aeronave/diario/reporte/aprovar';
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              aircraft_logbook_report_id: '',
              approval_type: '',
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      // Após clicar para aprovar o reporte
      handleApproval(id, type) {
        if (type === 'approve') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              aircraft_logbook_report_id: id,
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e enviar os dados desta discrepância técnica para o Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.approve();
          }
        }

        if (type === 'delete') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              aircraft_logbook_report_id: id,
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e enviar o arquivamento desta discrepância técnica para o Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.delete();
          }
        }
      }

      // Após preencher as credenciais do Logbook App
      handleLogbookSignatureSubmit(credentials) {
        // Recebe { email, password } do modal e atualiza o state
        this.setState({
          email: credentials.email,
          password: credentials.password,
          showLogbookSignatureModal: false
        }, () => {
          // Após informar as credenciais, chama a função de aprovação interna
          if (this.state.approval_type === 'approve') {
            this.approve();
          }
          if (this.state.approval_type === 'delete') {
            this.delete();
          }
        });
      }
        
      render() {
        var self = this;
        return (
      <div>
      <RequestApi ref={'request_api'} />
      <Overlay overlay={this.state.overlay} handleAlert={this.props.handleAlert} />
        <h3 className="page-title pull-left">Reports of Crew or Maintenance</h3>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Flight Leg</label>
                <Select
                  className="form-group"
                  name="aircraft_logbook_flight_id"
                  value={this.state.aircraft_logbook_flight_id}
                  searchable={true}
                  placeholder={'Select'}
                  onChange={this.handleSelectChange.bind(this, 'aircraft_logbook_flight_id')}
                  options={this.state.flight_legs_list}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Location</label>
                <Select
                  className="form-group"
                  name="location_id"
                  value={this.state.location_id}
                  searchable={true}
                  placeholder={'Select'}
                  onChange={this.handleSelectChange.bind(this, 'location_id')}
                  options={this.state.locations_list}
                  required
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Detected By</label>
                <Select
                  className="form-group"
                  name="user_id"
                  value={this.state.user_id}
                  searchable={true}
                  placeholder={'Select'}
                  onChange={this.handleSelectChange.bind(this, 'user_id')}
                  options={this.state.users_list}
                  required
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Detected At</label>
                <br/>
                <InputMask value={this.state.date} name="date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={'dd/mm/aaaa hh:mm'} required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Description</label>
                <br/>
                <textarea style={{ height: 35 }} type="text" name="description" className="form-control" value={this.state.description} onChange={this.handleChange.bind(this, 'description')} required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Reports</caption>
            <thead>
              <tr>
                <th>Item</th>
                <th>Flight Leg</th>
                <th>Location</th>
                <th>Detected By</th>
                <th>Detected At</th>
                <th>Description</th>
                <th>Approved By</th>
                <th>Approved At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody id="reports">
            {Object.keys(self.state.reports).map(function(k) {
              var report = self.state.reports[k];
              return(
              <tr className="text-center" key={report.id}>
                <td>{report.item}</td>
                <td>{report.leg}</td>
                <td>{report.location_name}</td>
                <td>{report.user_name}</td>
                <td>{report.date_str}</td>
                <td>{report.description}</td>
                <td>{report.approval_user_name}</td>
                <td>{report.approval_date_str}</td>
                <td>
                  <div className="btn-group">
                      {
                        (self.state.report_trash == 1) &&
                          <button onClick={() => {self.handleApproval(report.id, 'delete')}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
                      }
                      {
                        (report.approval_date == null) ?
                          <button onClick={() => {self.handleApproval(report.id, 'approve')}} className="btn btn-success btn-sm button-inline">
                            <i className="fa fa-check"></i>
                          </button>
                        :
                          <button className="btn btn-success btn-sm button-inline" disabled>
                            <i className="fa fa-check"></i>
                          </button>
                      }
                    </div>
                </td>
              </tr>
              );
            })}
            </tbody>
          </table>
        </div>
        {/* Modal de assinatura do LogbookApp */}
        <LogbookSignatureModal
          show={this.state.showLogbookSignatureModal}
          onHide={() => this.setState({ showLogbookSignatureModal: false })}
          onSubmit={this.handleLogbookSignatureSubmit}
          title={this.state.signature_modal_title}
          subtitle={this.state.signature_modal_subtitle}
          confirmation={this.state.signature_modal_confirmation}
        />
      </div>
    );
  }
}

export default AircraftLogbookReportsTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookReportsTab.js